// components/organization/UsersFilters.jsx
import React, { useMemo, useState } from "react";
import { X } from "lucide-react";

const SORT_OPTIONS = [
  { value: "-createdAt", label: "جدیدترین" },
  { value: "createdAt", label: "قدیمی‌ترین" },
  { value: "name", label: "نام (صعودی)" },
  { value: "-name", label: "نام (نزولی)" },
];

const LIMIT_OPTIONS = [10, 20, 50, 100];

const UsersFilters = ({
  q,
  setQ,
  tags,
  setTags,
  allTags,
  setAllTags,
  sort,
  setSort,
  limit,
  setLimit,
  onApply,
  onReset,
  isRtl = true,
}) => {
  const [tagInput, setTagInput] = useState("");

  const addTag = () => {
    const val = tagInput.trim();
    if (!val) return;
    if (!tags.includes(val)) setTags([...tags, val]);
    setTagInput("");
  };

  const removeTag = (t) => {
    setTags(tags.filter((x) => x !== t));
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <div
      className={`flex flex-col gap-3 bg-white p-4 rounded-xl border ${
        isRtl ? "" : ""
      }`}
    >
      {/* ردیف اول: جستجو + تگ‌ها */}
      <div className="flex flex-col md:flex-row gap-3">
        <div className="flex-1">
          <label className="block text-sm mb-1">جستجو (نام/موبایل/ایمیل)</label>
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="w-full border rounded-md px-3 py-2"
            placeholder="مثلاً: علی یا 0912 یا example@mail.com"
          />
        </div>

        <div className="flex-1">
          <label className="block text-sm mb-1">
            تگ‌ها (Enter برای افزودن)
          </label>
          <div className="flex items-center gap-2">
            <input
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyDown={onKeyDown}
              className="w-full border rounded-md px-3 py-2"
              placeholder="teacher, editor, ..."
            />
            <button
              onClick={addTag}
              className="px-3 py-2 bg-purple-600 text-white rounded-md"
            >
              افزودن
            </button>
          </div>
          {tags.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-2">
              {tags.map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center gap-1 px-2 py-1 text-sm bg-purple-100 text-purple-700 rounded-full"
                >
                  {t}
                  <button
                    onClick={() => removeTag(t)}
                    className="hover:text-red-600"
                  >
                    <X size={14} />
                  </button>
                </span>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ردیف دوم: allTags + sort + limit + اعمال/ریست */}
      <div className="flex flex-col md:flex-row items-start  gap-3">
        <div className="md:ms-auto flex items-end gap-3">
          <div>
            <label className="block text-sm mb-1">مرتب‌سازی</label>
            <select
              value={sort}
              onChange={(e) => setSort(e.target.value)}
              className="border rounded-md px-3 py-2"
            >
              {SORT_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm mb-1">تعداد در صفحه</label>
            <select
              value={limit}
              onChange={(e) => setLimit(parseInt(e.target.value, 10))}
              className="border rounded-md px-3 py-2"
            >
              {LIMIT_OPTIONS.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </div>

          <button
            onClick={onApply}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            اعمال فیلتر
          </button>
          <button
            onClick={onReset}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
          >
            ریست
          </button>
        </div>
      </div>
    </div>
  );
};

export default UsersFilters;
